module.exports = __webpack_public_path__ + "img/4_107.f9ec8c50.png";